export const API_STATUS = {
  IDLE: "idle",
  LOADING: "loading",
  SUCCESS: "success",
  ERROR: "error",
};
export const API_URL = "https://dhrutham-cart-backend.herokuapp.com";
